var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tv-page',{class:_vm._.page,attrs:{"title":"模板","loading":_vm.loading}},[(!_vm.loading)?[_c('div',{class:_vm._.hd},[_vm._v("头部")])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }